import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import styles from './TimeRangeToggle.css';

const TimeRangeToggle = ({
    data,
    selectedTimeRange,
    handleChange,
    monthAndYearFilter
}) => (
    <div>
        <div
            className="nav-wrapper button-align desktop"
            style={{ textAlign: 'center' }}
        >
            {data.map((ele) => (
                <button
                    key={ele.label}
                    className={cn('toggle-button', {
                        'active-btn': selectedTimeRange === ele.count
                    })}
                    onClick={() => monthAndYearFilter(ele.count)}
                    type="button"
                >
                    {ele.label}
                </button>
            ))}
        </div>
        <div className="nav-wrapper mobile" style={{ textAlign: 'center' }}>
            <select
                onChange={handleChange}
                className="selectwrap"
                value={selectedTimeRange}
            >
                <option value="3">3 Month</option>
                <option value="6">6 Month</option>
                <option value="12">1 Year</option>
                <option value="60">5 Year</option>
                <option value="120">10 Year</option>
                <option value="-1">Since Inception</option>
            </select>
        </div>
        <style jsx>{styles}</style>
    </div>
);

TimeRangeToggle.defaultProps = {
    data: [],
    handleChange: () => {},
    monthAndYearFilter: () => {},
    selectedTimeRange: -1
};

TimeRangeToggle.propTypes = {
    /**
     * Data elements to represent in the legend
     */
    data: PropTypes.instanceOf(Array),

    selectedTimeRange: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    /**
     * change event callback
     */
    handleChange: PropTypes.func,

    /**
     * filter event callback
     */
    monthAndYearFilter: PropTypes.func
};

export default TimeRangeToggle;
